import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbDateStruct, NgbCalendar, NgbDateParserFormatter, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectComponent } from '@ng-select/ng-select';
import { GridApi, ColumnApi, GridOptions, ColDef, RowClickedEvent, PaginationChangedEvent, GridReadyEvent, Column, FilterChangedEvent, FilterModifiedEvent, FilterOpenedEvent, ITooltipParams } from 'ag-grid-community';
import * as FileSaver from 'file-saver';
import { AlertService } from 'src/app/_services/alert.service';
import { MenusService } from 'src/app/_services/menu.service';
import { StorageService } from 'src/app/_services/storage.service';
import { BtnCellRenderer1 } from 'src/app/common/button-cell-renderer.component1';
import { ModalComponent } from 'src/app/common/modal/modal.component';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import { SideNavService } from 'src/app/views/layout/sidebar/side-name.service';
import { SidebarComponent } from 'src/app/views/layout/sidebar/sidebar.component';
import { environment } from 'src/environments/environment';
import { ExchangeRateService } from '../../exchange-rates/exchange-rate-service';
import { MerchantService } from '../../merchants/merchant-master/merchant.service';
import { ProductService } from '../../product-management/product-service';
import { Location } from '@angular/common';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2';
import {MatSliderModule} from '@angular/material/slider';
import { param } from 'jquery';
import { BtnCellRendererEdit } from 'src/app/common/button-cell-renderer-editable-component';
import { InputCellRenderer } from 'src/app/common/input-cell-renderer.component';
import { InputFieldRenderer } from 'src/app/common/input-field-renderer-component';
import { SelectCellRenderer } from 'src/app/common/select-cell-renderer.component';
import { SelectFieldRenderer } from 'src/app/common/select-field-cell-renderer.component';
import { CountryMasterService } from './country-master-service';
import * as moment from 'moment';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx'

export class CustomFilter {
  "country": any;
  "rating"?: any;
  "score"?: any;
  "label"?:any;
}

export interface IMerchantData {
  "name": string,
  "merchantId": string,
  "businessName": string,
  "contactperson": string,
  "id": number,
  "contactno": string,
  "emailid": string,
  "state": string,
  "city": string,
  "isdeleted": string
}
const { API_URL, defaultPageSizeArr, defaultPageSize } = environment;

@Component({
  selector: 'app-country-master-rule',
  templateUrl: './country-master-rule.component.html',
  styleUrls: ['./country-master-rule.component.scss']
})
export class CountryMasterRuleComponent implements OnInit {

  @ViewChild('riskConfiguration') private riskConfigurationModal: ModalComponent;
  riskConfig : ModalConfig;

  @ViewChild('labelConfiguration') private labelConfigurationModal: ModalComponent;
  labelConfig : ModalConfig;

  public quickFilterShow: boolean = false;
  public pageSize: number = defaultPageSize;
  public pageSizeArr: any = defaultPageSizeArr;
  public searchMerName: string;
  public searchMID: string;
  public resellerPartnerId: string;
  public Status: string;
  public searchFromDate: NgbDateStruct;
  public searchToDate: NgbDateStruct;
  public selectedMerchant: string;
  public emailId: string;
  totalRecords: any;
  merchantStatus: any;
  modalConfigBlocked: ModalConfig;
  modalConfigReport: ModalConfig;
  user_type: 'NULL';
  tableInfo: any;
  maxSize: number;
  ellipses: boolean = true;
  private gridApi!: GridApi;
  public rowData!: any[];
  public customerDropDown: any;
  collectiondata: number = 0;
  collectionSize: number = 0;
  currentPage: number = 1;
  public permissions: any = '';
  Resultdata: any;
  resellerListOptions: any;
  merchantStatusdata: any;
  private gridColumnApi!: ColumnApi;
  currentDate: any = new Date();
  private filterObj: any = {};
  globalSearch: string = '';
  private innerWidth: number;
  modalConfigAdd: ModalConfig;
  modalConfigEdit: ModalConfig;
  modalConfigMerchant: ModalConfig;
  image: any;
  mindatadis: boolean = true;
  loading: boolean = false;
  orvreport: FormGroup;
  actionPermission: any;
  public gridOptions: GridOptions;
  public pageNumber: number = 0;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  maxDateFrom: NgbDateStruct;
  countryDropDown: any[];
  ratingNameList : any[];
  ratingList : any[];
  country: any;
  ratingSelected : any;
  labelSelected : any;
  score : any;
  lowFrom : any = 0;
  lowTo : any;
  medFrom : any
  medTo : any;
  highFrom : any;
  highTo : any = 10;
  labelList : any[] = [] ;
  labelListTest : any[];
  labelListSave : any[];
  labelName : any;
  public customerFilter : any;


  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 200,
    resizable: true,
    sortable: true,
    // suppressSizeToFit: true,
    // suppressAutoSize: true,
    filter: false,
    autoHeight: true
  };
  @ViewChild('modalReportCustomer') private modalReportComponent: ModalComponent;
  @ViewChild('modalblokedCustomer') private modalblockedComponent: ModalComponent;
  @ViewChild('filSearchMerName') private filSearchMerName: NgSelectComponent;
  @ViewChild('filSearchMID') private filSearchMID: NgSelectComponent;
  @ViewChild('filResellerPartnerId') private filResellerPartnerId: NgSelectComponent;
  @ViewChild('filStatus') private filStatus: NgSelectComponent;
  @ViewChild('filSearchToDate') private filSearchToDate: FormControl;
  @ViewChild('filSearchFromDate') private filSearchFromDate: FormControl;

  public columnDefs: ColDef[] = [
    { field: 'flag',lockVisible:true, headerName: 'Flag', resizable: true, cellClass: 'grid-cell-centered',cellRenderer: (params: any) => {
      return params.data.isLoading ? `<span class="spinner-border spinner-border-sm"></span>` : `<img src="${params.value}" width="40"/>`;
    },
    onCellClicked: (eve: any) => {
    }},
    { field: 'name',lockVisible:true, headerName: 'Country Name', },
    { field: 'rating',lockVisible:true, headerName: 'Rating' },
    {field: 'id', headerName: 'ID', hide: true },
    { field: 'score',lockVisible:true, headerName: 'Score', resizable: true, cellRenderer:  InputFieldRenderer,onCellValueChanged: (params: any) => {
      console.log(params.newValue);
        if (Number(params.newValue) <= 10) {
          console.log("Valid");
          const rowNode = this.gridApi.getRowNode((params.node.rowIndex).toString());
            if (rowNode) {
              let temp = "";
              console.log(this.lowFrom);
              if(Number(params.newValue) >= this.lowFrom && Number(params.newValue) <= this.lowTo ){
                temp = "LOW"
              }else if(Number(params.newValue) >= this.medFrom && Number(params.newValue) <= this.medTo ){
                temp = "MEDIUM"
              }else if(Number(params.newValue) >= this.highFrom && Number(params.newValue) <= this.highTo ){
                temp = "HIGH"
              }
              rowNode.setDataValue('rating',temp);
            } 
          }else{
            console.log("Not Valid");
            const rowNode = this.gridApi.getRowNode((params.node.rowIndex).toString());
            if(rowNode){
              
              rowNode.setDataValue('score',0);
            }
            
          }
        // }
      // }
    } },
    { field: 'labels',lockVisible:true,headerName: 'Label', cellRenderer: SelectFieldRenderer, cellEditorParams: {
      options: this.labelList
    },tooltipValueGetter: (params: ITooltipParams) => {
      return params.data.labels.join(', ');
    }},
    {
      field: 'actions',lockVisible:true, headerName: 'Actions', width: 280, cellRenderer: BtnCellRendererEdit, cellRendererParams: [
        {
          clicked: async (event: any, param: any) => {
            console.log(param.data.code);
            console.log(param.data.score);
            console.log(param.data.labels);
            console.log(param.data.editFlag);
            if(param.data.editFlag){
              
              let check :boolean = await this.updateCountry(param.data);
              console.log(check);
              if(check){
                param.data.editFlag = !param.data.editFlag 
                console.log(param.data.editFlag);
                return;
              }
            }else{
              param.data.editFlag = !param.data.editFlag 
              console.log(param.data.editFlag);
            }
          },
          buttonEditClass: 'icon-save',
          buttonSaveClass: 'icon-edit',
          buttonVisible: true
        }
      ]
    }
  ];

  columnDefsCopy: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  tableSelectedColumn: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  page = 1;


  constructor(private menuService: MenusService, private location: Location, private alertService: AlertService, private sideNavService: SideNavService, private merchantService: MerchantService, private router: Router, private sidebarComponent: SidebarComponent, private storageService: StorageService, private ngbCalender: NgbCalendar,
    private ngbDateParserFormatter: NgbDateParserFormatter,private modalService: NgbModal,private countryService : CountryMasterService, private formBuilder : FormBuilder) {

    this.maxDateFrom = this.ngbCalender.getToday();
    this.maxDate = this.ngbCalender.getToday();
    this.merchantService.getBusinessType().subscribe((data) => this.merchantStatus = data)
    console.log("============>", this.tableSelectedColumn);
    console.log("Defined column : ", this.columnDefsCopy);
  }

  async ngOnInit(): Promise<void> {
    this.ratingNameList = [];
    this.ratingList = [];
    this.innerWidth = window.innerWidth;
    this.customerFilter = new CustomFilter();
    this.setPageSize();
    const path = this.location.prepareExternalUrl(this.location.path());
    this.permissions = this.menuService.getPermissions(path);
    if (this.permissions == null || this.permissions == '' || !this.permissions) {
      this.alertService.errorAlert({
        title: "No Access",
        backdrop: true,
        toast: true,
        timer: 1500
      })
      await this.router.navigateByUrl('/');
    }

    this.riskConfig = {
      modalTitle: "Risk Rating Configuration",
      modalSize: 'lg',
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }

    this.labelConfig = {
      modalTitle: "Label Configuration",
      modalSize: 'xl',
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }

    this.labelListSave= []
    this.ratingNameList = [{"name":"LOW"},{"name":"MEDIUM"},{"name":"HIGH"}]
    
    this.countryService.getRatingList().subscribe((response:any)=>{
      console.log(response);
      this.ratingList = response.response.data;
      for(let i:number = 0; i<this.ratingList.length ; i++){
        if(this.ratingList[i].name == "LOW"){
          this.lowFrom = this.ratingList[i].valueFrom;
          this.lowTo = this.ratingList[i].valueTo;
        }else if(this.ratingList[i].name == "MEDIUM"){
          this.medFrom = this.ratingList[i].valueFrom;
          this.medTo = this.ratingList[i].valueTo;
        }else if(this.ratingList[i].name == "HIGH"){
          this.highFrom = this.ratingList[i].valueFrom;
          this.highTo = this.ratingList[i].valueTo;
        }
      }
    })

    this.countryService.getLabelList().subscribe((response:any)=>{
      console.log(response);
      this.labelList.splice(0,this.labelList.length);
      this.labelListTest = response.response.data;
      this.labelListTest = this.labelListTest.map((_: any) => {
        _.style = "background-color: rgb(223, 161, 17);";
        return _;
      });
      this.labelListTest.forEach((item)=>this.labelList.push(item));
      console.log(this.labelList);
    })

    this.customerFilter.country = "";
    this.customerFilter.score = "";
    this.customerFilter.rating = "";
    this.customerFilter.label = "";
  }

  
  imageCellRenderer(url: any, indVal: number) {
    // console.log(url);
    // console.log(indVal);
      this.countryService.getFlagImage(url).subscribe(
        (data: any) => {
          console.log(data);
          if(this.rowData[indVal]){
            this.rowData[indVal].isLoading = false;
            if (data.type == 'image/png'|| data.type == 'image/jpeg') {
              const blobUrl = URL.createObjectURL(data);
              console.log(blobUrl);
              this.rowData[indVal].flag = blobUrl;
            } else {
              this.rowData[indVal].flag = 'assets/images/product.png';
            }
            this.gridApi.applyTransaction({ update: [this.rowData[indVal]] });
        }
      
        }, err => {
          if(this.rowData[indVal]){
            this.rowData[indVal].isLoading = false;
            this.rowData[indVal].flag = 'assets/images/product.png';
            this.gridApi.applyTransaction({ update: [this.rowData[indVal]] });
          }
        }
      )
  }

  async updateCountry(data:any){
    let updated;
    if(data.score == "" || data.score == undefined){
      this.alertService.toastWarringMessageAlertWithMessage("Please enter score");
      return false;
    }
    // if(data.labels.length == 0){
    //   this.alertService.toastWarringMessageAlertWithMessage("Please select label");
    //   return false;
    // }
    console.log("Code : "+data.code+" Score : "+data.score+" Labels : "+data.labels)
    let formData = {
      "code": data.code,
      "score": data.score,
      "labels": data.labels,
    }
    var res = await this.countryService.updateCountryByCode(formData).toPromise();
    console.log(res.response.status);
    updated = res.response.status;
    console.log(updated);
    if(updated == 200){
      Swal.fire('Country updated successfully','','success');
      return true;
    }else{
      Swal.fire('Error while updating the country','','error');
      return false;
    }
  }

  riskButton(){
    this.riskConfigurationModal.open();
  }

  labelButton(){
    this.labelConfigurationModal.open();
  }

  saveRiskRatingConfig(){
    if(this.lowTo == "" || this.lowTo == undefined){
      this.alertService.toastWarringMessageAlertWithMessage("Please enter Low To Rating");
      return;
    }
    if(this.medFrom == "" || this.medFrom == undefined){
      this.alertService.toastWarringMessageAlertWithMessage("Please enter Medium To Rating");
      return;
    }
    if(this.medTo == "" || this.medTo == undefined){
      this.alertService.toastWarringMessageAlertWithMessage("Please enter Medium To Rating");
      return;
    }
    if(this.highFrom == "" || this.highFrom == undefined){
      this.alertService.toastWarringMessageAlertWithMessage("Please enter High From Rating");
      return;
    }
    if(parseFloat(this.lowFrom) >=   parseFloat(this.lowTo)){
      this.alertService.toastWarringMessageAlertWithMessage("Low To cannot be greater than Low From");
      return;
    }
    if(parseFloat(this.medFrom) >=   parseFloat(this.medTo)){
      this.alertService.toastWarringMessageAlertWithMessage("Medium To cannot be greater than Medium From");
      return;
    }
    if(parseFloat(this.highFrom) >=   parseFloat(this.highTo)){
      this.alertService.toastWarringMessageAlertWithMessage("High To cannot be greater than High From");
      return;
    }

    let data = [{"name":"LOW","valueFrom":parseFloat(this.lowFrom),"valueTo":parseFloat(this.lowTo)},{"name":"MEDIUM","valueFrom":parseFloat(this.medFrom),"valueTo":parseFloat(this.medTo)},{"name":"HIGH","valueFrom":parseFloat(this.highFrom),"valueTo":parseFloat(this.highTo)}];
    console.log(data);
    this.countryService.updateRatingList(data).subscribe((response:any)=>{
      console.log(response);
      if(response.response.status == 200){
        this.riskConfigurationModal.close();
        Swal.fire('Risk Rating Configuration Saved Successfully','','success');
        this.countryService.getCountryListAll("","","","",10, 0)
        .subscribe((data: any) => {
        console.log(data);
        let newData = data.response.data.content.map((_: any) => {
          _.isLoading = true;
          _.lastLogin = _.lastLogin || '--'
          _.createdOn = _.createdOn ? moment(_.createdOn).format('DD-MM-YYYY, HH:mm') : _.createdOn;
          return _;
        });
        this.rowData = newData;
        data.response.data.content.map((_: any, i: number) => {
          setTimeout(() => {
            this.imageCellRenderer(_.flag, i);
          }, 200);
        })
        this.rowData = data.response.data.content;
        this.collectiondata = data.response.data.content,
        this.collectionSize = data.response.data.totalElements,
        console.log("Collection Size : " + this.collectionSize);
      });
      }else{
        Swal.fire('Error while updating the risk rating configuration','','error');
      }
    }) 
  }

  saveLabelConfig(){
    Swal.fire('Label Configuration Saved Successfully','','success');
    this.labelConfigurationModal.close();
  }

  deleteLabel(id:any){
    console.log(id);
    let count = 0;
    let data = this.labelList[id].label;
    for(let i :number = 0; i<this.labelListSave.length; i++){
      if(this.labelListSave[i].label == data){
        this.labelListSave.splice(i,1);
        count = 1;
      }
    }
    let deleteData = this.labelList[id];
    this.labelList.splice(id,1);
    console.log(count);
    if(count == 0){
      this.countryService.deleteLabelByName(data).subscribe((response:any)=>{
        console.log(response);
        if(response.response.status == 200){
          Swal.fire('Label deleted successfully','','success');
        }else{
          this.labelList.push(deleteData);
          Swal.fire('Error while deleting the label','','error');
        }
      })
    }
  }

  addNewlabel(){
    console.log(this.labelName);
    const val = {"label":this.labelName, "style":"background-color: rgb(238, 60, 60);","deletable":true};
    const value = {"label":this.labelName};
    this.labelList.push(val);
    this.labelListSave.push(value);
    this.labelName = "";
    console.log(this.labelList);
    console.log(this.labelListSave);
  }

  lowToChange(event :any){
   this.lowTo = event.value;
    console.log(this.lowTo);
    if(parseFloat(this.lowTo) > 9){
      console.log("breach");
      this.medFrom = 0;
      console.log(this.lowTo);
      this.lowTo = '';
      return;
    }else if(this.lowTo == ""){
      this.medFrom = 0;
      return;
    }else{
      const temp = 0.01;
      this.medFrom = (parseFloat(this.lowTo) + temp).toFixed(2);
      return;
    }
  }

  medToChange(event :any){
    console.log(this.medFrom);
    if(this.medFrom == "" || this.medFrom == undefined){
      this.highFrom = '';
      this.medTo = '';
      event.value = '';
      console.log(this.medTo);
      console.log(event.value);
      console.log(this.medFrom);
      return;
    }
    this.medTo = event.value;
    console.log(this.medTo);
     if(parseFloat(this.medTo) > 9){
       console.log("breach");
       this.highFrom = 0;
       console.log(this.medTo);
       this.medTo = '';
       return;
     }else if(this.medTo == ""){
       this.highFrom = 0;
       return;
     }else{
       const temp = 0.01;
       this.highFrom = (parseFloat(this.medTo) + temp).toFixed(2);
       return;
     }
   }

  cancelButton(){
    this.labelConfigurationModal.close();
  }
  cancelRiskButton(){
    this.countryService.getRatingList().subscribe((response:any)=>{
      console.log(response);
      this.ratingList = response.response.data;
      for(let i:number = 0; i<this.ratingList.length ; i++){
        if(this.ratingList[i].name == "LOW"){
          this.lowFrom = this.ratingList[i].valueFrom;
          this.lowTo = this.ratingList[i].valueTo;
        }else if(this.ratingList[i].name == "MEDIUM"){
          this.medFrom = this.ratingList[i].valueFrom;
          this.medTo = this.ratingList[i].valueTo;
        }else if(this.ratingList[i].name == "HIGH"){
          this.highFrom = this.ratingList[i].valueFrom;
          this.highTo = this.ratingList[i].valueTo;
        }
      }
    })
    this.riskConfigurationModal.close();
  }

  refreshCountries() {

  }

  saveLabel(){
    if(this.labelListSave.length == 0){
      this.alertService.toastWarringMessageAlertWithMessage("No new label to be save");
      return;
    }
    console.log(this.labelListSave);
    this.countryService.updateLabelList(this.labelListSave).subscribe((response:any)=>{
      console.log(response);
      if(response.response.status == 200){
        this.labelConfigurationModal.close();
        Swal.fire('Labels saved successfully','','success');
        this.countryService.getLabelList().subscribe((response:any)=>{
          console.log(response);
          this.labelList.splice(0,this.labelList.length);
          this.labelListTest = response.response.data;
          this.labelListTest = this.labelListTest.map((_: any) => {
            _.style = "background-color: rgb(223, 161, 17);";
            return _;
          });
          this.labelListTest.forEach((item)=>this.labelList.push(item));
          console.log(this.labelList);
        })
      }else{
        Swal.fire('Error while saving the label','','error');
      }
    })
    
  }

  setPageSize() {
    if (this.innerWidth <= 1600 && this.innerWidth >= 1200) {
      this.maxSize = 5;
    } else if (this.innerWidth <= 1199 && this.innerWidth >= 768) {
      this.maxSize = 3;
      this.ellipses = false;
    } else if (this.innerWidth < 768) {
      this.maxSize = 2;
      this.ellipses = false;
    }
  }
  updateSelectedColumn(event: any) {
    console.log("select col : " + event.target.checked);
    if (event.target.checked) {
      console.log(this.columnDefsCopy[parseInt(event.target.value)].field);
      console.log(this.permissions);
      if (this.columnDefsCopy[parseInt(event.target.value)].field == "actions" && this.permissions == "View") {
        console.log("Action Disabled");
        this.gridApi.setColumnDefs(this.tableSelectedColumn)
        this.gridApi.setDefaultColDef(this.defaultColDef);
        return;
      }

      if (this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]) < 0) {
        // this.tableSelectedColumn.push(this.columnDefs[parseInt(event.target.value)]);
        this.tableSelectedColumn.splice(parseInt(event.target.value), 0, this.columnDefsCopy[parseInt(event.target.value)]);
      }
    } else {
      if (this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]) > -1) {
        this.tableSelectedColumn.splice(this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]), 1);
      }
    }
    console.log("selected Column : " + JSON.stringify(this.tableSelectedColumn));

    this.gridApi.setColumnDefs(this.tableSelectedColumn)
    this.gridApi.setDefaultColDef(this.defaultColDef);
  }


  onExportCSV() {
    debugger
    // @ts-ignore
    const random3 = Math.floor(Math.random() * 10000000000 + 1);
    const today = new Date();
    const referenceId = today.getFullYear().toString() + "-" + ("0" + (today.getMonth() + 1)).slice(-2) + "-" + ("0" + today.getDate()).slice(-2) + "_" + (("0" + today.getHours())).slice(-2) + "-" + (("0" + today.getMinutes())).slice(-2) + "-" + (("0" + today.getSeconds())).slice(-2);
    const fileName = 'Exchange_List' + "_" + referenceId;
    if(this.ratingSelected == null || this.ratingSelected == "" || this.ratingSelected == undefined){
      this.ratingSelected = null;
    }
    console.log(this.ratingSelected);
    console.log(this.country);
    console.log(this.score);
    if(!this.country){
      this.country = "";
    }
    if(!this.ratingSelected){
      this.ratingSelected = null;
    }
    if(!this.score){
      this.score = "";
    }
    if(!this.labelSelected){
      this.labelSelected = "";
    }
    console.log(this.pageSize);
    console.log(this.pageNumber);
    console.log(this.customerFilter);
    return this.countryService.getCountryListAll(this.customerFilter.country,this.customerFilter.rating,this.customerFilter.score,this.customerFilter.label,this.pageSize, this.pageNumber)
      .subscribe((data:any) => {
        debugger
        const expData: any[] = [];
        console.log("Customer Data ::" + JSON.stringify(data));

        if (data == "" || data.response.data.content.length == 0) {
          this.alertService.errorAlertWithMessage("No records present");
          return
        }
        (data?.data || data.response.data.content || []).forEach((curr: any) => {
          const tempRec: any = {}
          // this.tableSelectedColumn.forEach((col) => {
          //   if (col?.field) tempRec[col?.field] = curr[col?.field]
          // })
          this.tableSelectedColumn.forEach((col) => {
            debugger
            if (!(col?.field == "actions")) {
              if (col?.field) tempRec[col?.field] = curr[col?.field]
            }

          })
          expData.push(tempRec);
        })

        // this.JSONToCSVConvertor(data?.data || data?.merchants || data || [],fileName, "Report");
        this.exportAsExcelFile(expData, fileName);
      });



     
  }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const tempRec: any = []
    var index = 0;
    this.tableSelectedColumn.forEach((col) => {
      if (!(col?.field == "screen")) {
        if (!(col?.field == "actions")) {
          tempRec[index] = col
          index++;

        }

      }
    })
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet([], {
      // @ts-ignore
      header: [...tempRec.map((col: any) => col.headerName)]
    });
    // const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    const wb = XLSX.utils.book_new();
    XLSX.utils.sheet_add_aoa(worksheet, [[...tempRec.map((col: any) => col.headerName)]]);
    XLSX.utils.sheet_add_json(worksheet, json, { origin: 'A2', skipHeader: true });
    XLSX.utils.book_append_sheet(wb, worksheet, 'Sheet1');
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + new Date().getTime() + EXCEL_EXTENSION);
  }

  resetFilter() {
    this.country = "";
    this.ratingSelected = null;
    this.score = "";
    this.labelSelected = "";
    this.customerFilter = new CustomFilter();
    this.customerFilter.country = "";
    this.customerFilter.score = "";
    this.customerFilter.rating = "";
    this.customerFilter.label = "";
    // this.filStatus.handleClearClick();
  }

  onSearchBtnClick($event: Event) {

    console.log(this.ratingSelected);
    console.log(this.country);
    console.log(this.score);
    if(!this.country){
      this.country = "";
    }else{
      this.customerFilter.country = this.country;
    }
    if(!this.ratingSelected){
      this.ratingSelected = null;
    }else{
      this.customerFilter.rating = this.ratingSelected;
    }
    if(!this.score){
      this.score = "";
    }else{
      this.customerFilter.score = this.score;
    }
    if(!this.labelSelected){
      this.labelSelected = "";
    }else{
      this.customerFilter.label = this.labelSelected;
    }
    console.log(this.customerFilter);
    console.log(this.pageSize);
    console.log(this.pageNumber);
    this.pageNumber = 0;
    console.log(this.customerFilter);
    return this.countryService.getCountryListAll(this.customerFilter.country,this.customerFilter.rating,this.customerFilter.score,this.customerFilter.label,this.pageSize, this.pageNumber)
      .subscribe((data:any) => {
        let newData = data.response.data.content.map((_: any) => {
          _.isLoading = true;
          _.lastLogin = _.lastLogin || '--'
          _.createdOn = _.createdOn ? moment(_.createdOn).format('DD-MM-YYYY, HH:mm') : _.createdOn;
          return _;
        });
        this.rowData = newData;
        data.response.data.content.map((_: any, i: number) => {
          setTimeout(() => {
            this.imageCellRenderer(_.flag, i);
          }, 200);
        })
        this.rowData = data.response.data.content || [],
          this.collectiondata = data.response.data.content || 0
          this.collectionSize = data.response.data.totalElements
        if (this.rowData.length <= 0) {
          this.alertService.errorAlertWithMessage("No records present");
          return
        }
      });
  }

  async onRowDoubleClicked(param: RowClickedEvent | any) {
    console.log("Edit CLicked");
    return await this.router.navigate(['/customerEdit'], {

      queryParams: {
        mid: param?.data?.registeredMobile,
        date: param?.data?.createdDate,


      }
    })

  }
  onRowClicked(param: RowClickedEvent | any) {
    console.log("Row Clicked", param);
  }
  getToday(): string {
    return new Date().toISOString().split('T')[0]
  }

  onPaginationChange(param: PaginationChangedEvent | any) {

    console.log(this.ratingSelected);
    console.log(this.country);
    console.log(this.score);
    if(!this.country){
      this.country = "";
    }
    if(!this.ratingSelected){
      this.ratingSelected = null;
    }
    if(!this.score){
      this.score = "";
    }
    if(!this.labelSelected){
      this.labelSelected = "";
    }
    this.pageNumber = (param-1);
    console.log(this.pageSize);
    console.log("selected page number : " + this.pageNumber);
    console.log(this.customerFilter);
    this.countryService.getCountryListAll(this.customerFilter.country,this.customerFilter.rating,this.customerFilter.score,this.customerFilter.label,this.pageSize, this.pageNumber)
      .subscribe((data:any) => {
        let newData = data.response.data.content.map((_: any) => {
          _.isLoading = true;
          _.lastLogin = _.lastLogin || '--'
          _.createdOn = _.createdOn ? moment(_.createdOn).format('DD-MM-YYYY, HH:mm') : _.createdOn;
          return _;
        });
        this.rowData = newData;
        data.response.data.content.map((_: any, i: number) => {
          setTimeout(() => {
            this.imageCellRenderer(_.flag, i);
          }, 200);
        })
        this.rowData = data.response.data.content|| data,
        this.collectiondata = data.response.data.content,
        this.collectionSize = data.response.data.totalElements,
        this.gridApi.applyTransaction({ add: this.rowData })});
    console.log("Collection Size : " + this.collectionSize);

  }



  onPageSizeChanges($event: Event) {
    this.gridApi.paginationSetPageSize(this.pageSize)
    this.gridApi.applyTransaction({ remove: this.rowData })
    this.gridApi.showLoadingOverlay();
    console.log(this.ratingSelected);
    console.log(this.country);
    console.log(this.score);
    if(!this.country){
      this.country = "";
    }
    if(!this.ratingSelected){
      this.ratingSelected = null;
    }
    if(!this.score){
      this.score = "";
    }
    if(!this.labelSelected){
      this.labelSelected = "";
    }
    console.log(this.pageSize);
    this.pageNumber = 0;
    console.log("selected page number : " + this.pageNumber);
    console.log(this.customerFilter);
    this.countryService.getCountryListAll(this.customerFilter.country,this.customerFilter.rating,this.customerFilter.score,this.customerFilter.label,this.pageSize, this.pageNumber)
      .subscribe((data:any) => {
        let newData = data.response.data.content.map((_: any) => {
          _.isLoading = true;
          _.lastLogin = _.lastLogin || '--'
          _.createdOn = _.createdOn ? moment(_.createdOn).format('DD-MM-YYYY, HH:mm') : _.createdOn;
          return _;
        });
        this.rowData = newData;
        data.response.data.content.map((_: any, i: number) => {
          setTimeout(() => {
            this.imageCellRenderer(_.flag, i);
          }, 200);
        })
        this.rowData = data.response.data.content|| data,
        this.collectiondata = data.response.data.content,
        this.collectionSize = data.response.data.totalElements,
        this.gridApi.applyTransaction({ add: this.rowData })});
    console.log("Collection Size : " + this.collectionSize);
    this.pageNumber = 0;
  }

  onGridReady(params: GridReadyEvent<IMerchantData>) {
    
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    if (this.permissions == "View") {
      this.gridColumnApi.setColumnsVisible(["actions"], false);
    }
    this.gridApi.getFilterInstance('age', (filterParam) => {
    })
    this.gridApi.showLoadingOverlay();
    this.gridApi.setQuickFilter(this.globalSearch);
    const allColumnIds: (string | Column)[] = [];
    params?.columnApi?.getColumns()?.forEach((column) => {
      allColumnIds.push(column.getId());
    });
    params?.columnApi?.autoSizeColumns(allColumnIds, false);
    console.log(this.ratingSelected);
    console.log(this.country);
    console.log(this.score);
    
    if(!this.country){
      this.country = "";
    }
    if(!this.ratingSelected){
      this.ratingSelected = null;
    }
    if(!this.score){
      this.score = "";
    }
    if(!this.labelSelected){
      this.labelSelected = "";
    }
    console.log(this.pageSize);
    console.log(this.pageNumber);
    console.log(this.customerFilter);
    return this.countryService.getCountryListAll(this.customerFilter.country,this.customerFilter.rating,this.customerFilter.score,this.customerFilter.label,this.pageSize, this.pageNumber)
      .subscribe((data: any) => {
        console.log(data);
        let newData = data.response.data.content.map((_: any) => {
          _.isLoading = true;
          _.lastLogin = _.lastLogin || '--'
          _.createdOn = _.createdOn ? moment(_.createdOn).format('DD-MM-YYYY, HH:mm') : _.createdOn;
          return _;
        });
        this.rowData = newData;
        data.response.data.content.map((_: any, i: number) => {
          setTimeout(() => {
            this.imageCellRenderer(_.flag, i);
          }, 200);
        })
        this.rowData = data.response.data.content;
        this.collectiondata = data.response.data.content,
          this.collectionSize = data.response.data.totalElements,
          console.log("Collection Size : " + this.collectionSize);
      });
  }

  quickFilterShowAction($event: Event) {
    this.quickFilterShow = !this.quickFilterShow
    if (!this.quickFilterShow) {
      this.filStatus.handleClearClick();
      this.refreshGrid();
    }
  }

  OnlyCharacterAllowed(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122) || (charCode == 32)) {
      // console.log('charCode restricted is' + charCode)
      return true;
    }
    return false;
  }
  changeDate() {
    this.currentDate = this.searchFromDate
    this.minDate = this.searchFromDate;
    let mmmm = this.ngbDateParserFormatter.format(this.searchFromDate);
  }


  changeEndDate() {
    this.currentDate = this.searchToDate;
    this.maxDateFrom = this.searchToDate;
  }

  onFilterChange(param: FilterChangedEvent | any) {

  }

  onFilterModified(param: FilterModifiedEvent | any) {
    // console.log("onFilterModified----->",param);
    const temp = param?.filterInstance;
    this.filterObj[param?.column?.colId] = temp;
  }

  onFilterOpened(param: FilterOpenedEvent | any) {
    console.log("onFilterOpened----->", param);
  }

  onSortChange(event: any) {
    const listOfSortModel = this?.gridColumnApi?.getColumnState().filter(s => s.sort !== null)
    console.log("==Sort===>", listOfSortModel);
  }
  allowAlfanumeric($event: Event): void {
    if (this.searchMID.length > 10) {
      return
    }

    this.searchMerName = this.searchMerName.replace(/[^a-z 0-9]/gi, '') || '';
    this.searchMID = this.searchMID.replace(/[^a-z 0-9]/gi, '') || '';
  }
  fun(id: any) {
    document?.getElementById(id)?.classList.add("hey")
  }
  funover(id: any) {
    document?.getElementById(id)?.classList.remove("hey")
  }

  refreshGrid() {
    this.gridApi.applyTransaction({ remove: this.rowData });
    return this.merchantService.getApprovedCustomer(this.pageSize, (this.currentPage - 1))
      .subscribe((data) => (this.rowData = data.data || data.merchants || data,
        this.collectiondata = data.totalCount || data.totalrecords || data.totalRecords || data.length, this.collectionSize = this.collectiondata - 10
      ));
  }

  closeModalBlocked($event: any) {
    if (!$event.showModal) {
      this.modalblockedComponent.close();
      this.refreshGrid();
    }
  }

  closeResult = '';
  openModal(content: any) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'xl', centered: true, modalDialogClass: 'permission-modal' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

}

